import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { E11DividerModule } from '@engineering11/ui-lib/e11-divider'
import {
  E11DynamicFormBuilderComponent,
  E11DynamicFormModule,
  e11FieldInputCheckBox,
  e11FormFor,
  e11FormLayoutInlineGrid,
  e11LayoutGroup,
} from '@engineering11/ui-lib/e11-form-builder'
import { ICheckboxOptions } from '@engineering11/ui-lib/e11-input-checkbox'
import { TranslateModule } from '@ngx-translate/core'
import { RequiredApplicationDetailKeys } from 'shared-lib'

type ContactDetailsKeys = Extract<RequiredApplicationDetailKeys, 'lastName' | 'email' | 'phoneNumber' | 'address'>
type RequiredCandidateDetailsForm = Record<ContactDetailsKeys, boolean>

@Component({
  selector: 'required-contact-details-form',
  standalone: true,
  imports: [E11DynamicFormModule, E11DividerModule, TranslateModule],
  template: `
    <div class="">
      <e11-dynamic-form-builder
        #requiredFieldsForm
        [fieldGroups]="fieldGroups"
        [hideSubmitMenu]="true"
        [loading]="loading"
        [initialValue]="_initialValue"
        (valueChanges)="onValueChanges($event)"
      >
        <ng-template e11Template="contactDetails">
          <p class="e11-font-extrabold">{{ 'Contact Details' | translate }}</p>
        </ng-template>
        <!-- <ng-template e11Template="divider">
          <e11-divider [margin]="0" />
        </ng-template> -->
        <!-- <ng-template e11Template="applicationDetails">
          <p class="e11-font-extrabold">{{ 'Application Details' | translate }}</p>
        </ng-template> -->
      </e11-dynamic-form-builder>
    </div>
  `,
})
export class RequiredContactDetailsFormComponent {
  @ViewChild('requiredFieldsForm') requiredFieldsForm!: E11DynamicFormBuilderComponent<RequiredCandidateDetailsForm>
  _initialValue?: RequiredCandidateDetailsForm
  @Input() set initialValue(value: RequiredApplicationDetailKeys[] | undefined) {
    if (!Array.isArray(value)) return
    this._initialValue = fromKeysToObject(value)
  }
  @Input() loading: boolean = false

  @Output() valueChanges = new EventEmitter<RequiredApplicationDetailKeys[]>()

  fieldGroups = this.buildForm()

  buildForm() {
    return e11FormFor<RequiredCandidateDetailsForm>()([
      e11LayoutGroup(
        [
          e11FormLayoutInlineGrid([
            e11FieldInputCheckBox('lastName', '', this.createOption('Name', 'lastName'), undefined, {
              validatorOrOpts: [],
              extraInputOption: { containerClass: 'e11-block' },
            }),
            e11FieldInputCheckBox('email', '', this.createOption('Email', 'email'), undefined, {
              validatorOrOpts: [],
              extraInputOption: { containerClass: 'e11-block' },
            }),
          ]),
          e11FormLayoutInlineGrid([
            e11FieldInputCheckBox('phoneNumber', '', this.createOption('Phone', 'phoneNumber'), undefined, {
              validatorOrOpts: [],
              extraInputOption: { containerClass: 'e11-block' },
            }),
            e11FieldInputCheckBox('address', '', this.createOption('Address', 'address'), undefined, {
              validatorOrOpts: [],
              extraInputOption: { containerClass: 'e11-block' },
            }),
          ]),
        ],
        {
          templateSpec: [
            {
              templateKey: 'contactDetails',
              templatePosition: 'top',
            },
            {
              templateKey: 'divider',
              templatePosition: 'bottom',
            },
          ],
        }
      ),

      // e11LayoutGroup(
      //   [
      //     e11FormLayoutInlineGrid([
      //       e11FieldInputCheckBox('resumeAttachment', '', this.createOption('Resume', 'resumeAttachment'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //       e11FieldInputCheckBox('summary', '', this.createOption('Summary', 'summary'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //     ]),
      //     e11FormLayoutInlineGrid([
      //       e11FieldInputCheckBox('firstImpression', '', this.createOption('First Impression', 'firstImpression'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //       e11FieldInputCheckBox('certifications', '', this.createOption('Certifications', 'certifications'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //     ]),
      //     e11FormLayoutInlineGrid([
      //       e11FieldInputCheckBox('workHistory', '', this.createOption('Work History', 'workHistory'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //       e11FieldInputCheckBox('portfolio', '', this.createOption('Portfolio', 'portfolio'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //     ]),
      //     e11FormLayoutInlineGrid([
      //       e11FieldInputCheckBox('education', '', this.createOption('Education', 'education'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //       e11FieldInputCheckBox('references', '', this.createOption('References', 'references'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //     ]),
      //     e11FormLayoutInlineGrid([
      //       e11FieldInputCheckBox('socialMedia', '', this.createOption('Social Media', 'socialMedia'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //       e11FieldInputCheckBox('languages', '', this.createOption('Languages', 'languages'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //     ]),
      //     e11FormLayoutInlineGrid([
      //       e11FieldInputCheckBox('militaryAffiliation', '', this.createOption('Military Affiliation', 'militaryAffiliation'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //       e11FieldInputCheckBox('skills', '', this.createOption('Skills', 'skills'), undefined, {
      //         validatorOrOpts: [],
      //         extraInputOption: { containerClass: 'e11-block' },
      //       }),
      //     ]),
      //   ],
      //   {
      //     templateSpec: [
      //       {
      //         templateKey: 'applicationDetails',
      //         templatePosition: 'top',
      //       },
      //     ],
      //   }
      // ),
    ])
  }
  private createOption(label: string, value: keyof RequiredCandidateDetailsForm): ICheckboxOptions[] {
    return [{ name: label, value, checkboxProps: { containerClass: 'e11-mb-2' } }]
  }
  onValueChanges(formData: RequiredCandidateDetailsForm) {
    this.valueChanges.emit(extractRequiredDetailKeys(formData))
  }
}

function extractRequiredDetailKeys(obj: RequiredCandidateDetailsForm): ContactDetailsKeys[] {
  return obj ? (Object.keys(obj) as ContactDetailsKeys[]).filter(key => obj[key]) : []
}
function fromKeysToObject(value: string[]): RequiredCandidateDetailsForm {
  return value.reduce((acc: RequiredCandidateDetailsForm, key) => {
    acc[key as ContactDetailsKeys] = true
    return acc
  }, {} as RequiredCandidateDetailsForm)
}
